import Bills from '../bills/Bills';
import { BillsShowModeType } from '../bills/BillsShowModeType';
import { Button, Container, Modal } from 'react-bootstrap';
import { useState } from 'react';
import Common from '../../shared/Common';

const VatBillItems = () => {
  const [selectedVatBillElements, setSelectedVatBillElements] = useState<[billItemId: number, vatPercentage: number][]>([]);
  const [showVatBillElementsModal, setShowVatBillElementsModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [elementDescriptionToSearch, setElementDescriptionToSearch] = useState<string | undefined>(undefined)
  const [fetchDataTrigger, setFetchDataTrigger] = useState(0);

  const handleShowVatBillElementsModal = () => {
    setShowVatBillElementsModal(true);
    setSelectedVatBillElements([]);
    setElementDescriptionToSearch(undefined);
  };
  const handleCloseVatBillElementsModal = () => {
    setShowVatBillElementsModal(false);
    setSelectedVatBillElements([]);
  };
  const handleSaveVatBillElementsModal = async () => {
    setShowVatBillElementsModal(false);
    await updateVatPercentage();
    setSelectedVatBillElements([]);
    setElementDescriptionToSearch(undefined);
  }

  const updateVatPercentage = async () => {
    setShowSpinner(true);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        changedBilItems: selectedVatBillElements.map((item) => ({
          billItemId: item[0],
          vatPercentage: item[1],
        })),
      }),
    };
    const response = await Common.authorizedFetch('api/bills/saveBillItemsVatPercentage', requestOptions);
    const data = await response.json();
    setShowSpinner(false);
    if (!data.success) {
      alert(data.errors);
    } 
    setFetchDataTrigger((prev) => prev + 1);
  };

  return (
    <Container className='mt-2'>
      {Common.Ui.showLoadingSpinnerFixed(showSpinner)}
      <h2>VAT</h2>
      <h4 id='tabelLabel' className='mb-3'>
        Elementy rachunków z odliczonym podatkiem VAT
      </h4>
      <Button variant='dark' className='mb-3' onClick={handleShowVatBillElementsModal}>
        Wybierz elementy
      </Button>
      <Bills
        showModeType={BillsShowModeType.Vat}
        selectedVatBillElementsChangedTrigger={fetchDataTrigger}
        onRowClick={(elementDescription) => {
          setElementDescriptionToSearch(elementDescription);
          setShowVatBillElementsModal(true);
          setSelectedVatBillElements([]);
        }}
      />
      <Modal size='lg' show={showVatBillElementsModal} onHide={handleCloseVatBillElementsModal}>
        <Modal.Header closeButton>
          <Modal.Title>Wybierz elementy rachunków z odliczonym podatkiem VAT</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Bills
            showModeType={BillsShowModeType.VatSelection}
            selectedVatBillElements={selectedVatBillElements}
            setSelectedVatBillElements={setSelectedVatBillElements}
            descriptionDefaultSearchValue={elementDescriptionToSearch}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className='me-sm-auto'>Liczba zmienioanych elementów: {selectedVatBillElements?.length}</div>
          <Button variant='dark' onClick={handleCloseVatBillElementsModal}>
            Zamknij
          </Button>
          <Button variant='primary' onClick={handleSaveVatBillElementsModal}>
            Zapisz
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default VatBillItems;
